export default __webpack_public_path__ + "static/media/usa.c2ae69d6.svg";